import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-account-edit-outline',
  templateUrl: './icon-account-edit-outline.component.html',
  styleUrl: './icon-account-edit-outline.component.scss',
  standalone: false,
})
export class IconAccountEditOutlineComponent {
  @Input() tooltip?: string;
}
